import {TenantInfo} from '../models/tenant.model';
import dayjs from "dayjs";
import {UserPermissions} from '../models/user-permissions.model';

export function isLifetimeCustomer(tenant:TenantInfo) {
  return tenant.instructorPricingPlan?.includes("lifetime");
}

/**
 *
 * if the customer is a lifetime user, show them periodically an
 * upgrade offer that gives an incentive to upgrade to a subscription plan.
 *
 */

export function showAppSumoUpgradeOffer(tenant: TenantInfo, permissions: UserPermissions) {
  return permissions.isAdmin && isLifetimeCustomer(tenant) && isAppSumoUpgradePeriod();
}

// Function to check if today's date is between the 10th and 15th of the current month
function isAppSumoUpgradePeriod() {
  const today = dayjs();  // Get today's date using Day.js
  const start = dayjs().date(10);  // Set to 10th of the current month
  const end = dayjs().date(15);    // Set to 15th of the current month

  // Check if today is between the 10th and the 15th (inclusive)
  return today.isSame(start, 'day') || today.isAfter(start) && today.isSame(end, 'day') || today.isBefore(end);
}

/**
 *
 * These are the AppSumo users with the original fully unlimited deal.
 *
 */

export function isAppSumoOriginalPlan(tenant:TenantInfo) {
  return tenant.instructorPricingPlan?.includes("lifetime") && !tenant?.appsumoTierLimits;
}

/**
 *
 * These are the AppSumo or StackCommerce users with the new deal that has usage limits.
 *
 */

export function isLimitedLifetimePlan(tenant:TenantInfo) {
  return tenant.instructorPricingPlan?.includes("lifetime") && !!tenant?.appsumoTierLimits;
}

export function isStackCommerce(tenant: TenantInfo) {
  return tenant.lifetimeCampaignName?.toLowerCase()?.includes("stack")
}

export function getDealSiteName(tenant: TenantInfo) {
  if (isStackCommerce(tenant)) {
    return "StackCommerce"
  }
  else {
    return "AppSumo";
  }
}
